import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { BiX } from "react-icons/bi";
import BwaiPromptList from "./Components/CreateTrivia/BwaiPromptList";
import CreateTriviaPopup from "./Components/CreateTrivia/CreateTriviaPopup";
import { BWAI_PROMPT_ACTION } from "./Components/CreateTrivia/createTriviaCopy";
import { BUILT_WITH_AI_PROMPTS_STANDARD } from "./data";
import "./Components/CreateTrivia/createTrivia.css";

export default function SurveySamplesPage({ open, onClose, ...props }) {
  const [createPopupOpen, setCreatePopupOpen] = useState(false);
  const [preSelectedPopupData, setPreselectedPopupData] = useState({
    selectedPrompt: "",
  });

  const closeCreatePopup = () => {
    setCreatePopupOpen(false);

  };

  const handlePromptSelect = (prompt) => {
    setCreatePopupOpen(true);
    setPreselectedPopupData({
      selectedPrompt: prompt.description,
    });
    onClose();
  };

  return (
    <div>
      {createPopupOpen &&
          preSelectedPopupData &&
          preSelectedPopupData.selectedPrompt ? (
            <CreateTriviaPopup
              open={createPopupOpen}
              onClose={closeCreatePopup}
              onAddSuccess={() => {
                props.history.push("list");
              }}
              preSelectedData={preSelectedPopupData}
              generateFromLibrary={false}
              user={props.user}
              autoSelectedTrivvyType="AI"
              onlyAllowCustomTextPrompt={true}
              history={props.history}
            />
          ) : (
            ""
          )}
      <Modal isOpen={open} centered className="bwai-modal">
        <ModalHeader
          className="bwai_modal_header"
          close={
            <BiX
              className="cursor-pointer"
              color="gray"
              size={30}
              onClick={onClose}
            />
          }
        >
          <span className="bwai_title_block">
            <span className="bwai_title_text">Survey Sample Prompts</span>
          </span>
        </ModalHeader>

        <ModalBody className="bwai_samples_body">
          <BwaiPromptList
            items={BUILT_WITH_AI_PROMPTS_STANDARD}
            actionLabel={BWAI_PROMPT_ACTION}
            className="bwai_prompt_list--samples"
            onSelect={handlePromptSelect}
          />
        </ModalBody>
      </Modal>
    </div>
  );
}
